import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faCog,
  faQuestionCircle,
  faTh,
  faUserCircle,
  faBars,
  faCalendarAlt,
  faRss,
  faJedi,
  faChartBar,
  faBolt,
  faSearch,
  faSyncAlt,
  faRedoAlt,
  faAddressBook,
  faTrashAlt,
  faPlus,
  faPlusCircle,
  faUser,
  faKey,
  faThList,
  faInfo,
  faInfoCircle,
  faArrowAltCircleLeft,
  faFileCsv,
  faAngleDoubleRight,
  faAngleDoubleDown,
  faSmile,
  faFrown,
  faThumbsUp,
  faThumbsDown,
  faPaperPlane,
  faPenSquare,
  faUserPlus,
  faTimes,
  faSave,
  faPen,
  faTimesCircle,
  faCheckCircle,
  faEllipsisV,
  faEdit,
  faEye,
  faDownload,
  faUsers,
  faClipboardCheck,
  faExclamationTriangle,
  faExclamationCircle,
  faExchangeAlt,
  faSearchPlus,
  faArrowRight,
  faList,
  faComments,
  faStar,
  faStarHalf,
  faPhoneAlt,
  faMobileAlt,
  faEnvelopeOpenText,
  faEnvelope,
  faBuilding,
  faHome,
  faCommentDots,
  faRobot,
  faUsersCog,
  faSitemap,
  faProjectDiagram,
  faFolderOpen,
  faChartLine,
  faBell,
  faHeart,
  faHandHoldingHeart,
  faQrcode,
  faTags,
  faBullseye,
  faClipboard,
  faPaperclip,
  faInfinity,
  faReply,
  faReplyAll,
  faCommentAlt,
  faEllipsisH,
  faClock,
  faFlag,
  faTable,
  faThLarge,
  faAngleLeft,
  faAngleRight,
  faChevronDown,
  faSms,
  faLock,
  faLockOpen,
  faMapMarkerAlt,
  faHourglass,
  faFolderPlus,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faCog,
  faQuestionCircle,
  faTh,
  faThList,
  faUserCircle,
  faBars,
  faCalendarAlt,
  faRss,
  faJedi,
  faChartBar,
  faBolt,
  faSearch,
  faSyncAlt,
  faRedoAlt,
  faAddressBook,
  faTrashAlt,
  faInfo,
  faPlusCircle,
  faPlus,
  faUser,
  faKey,
  faInfoCircle,
  faArrowAltCircleLeft,
  faFileCsv,
  faAngleDoubleRight,
  faAngleDoubleDown,
  faSmile,
  faFrown,
  faThumbsUp,
  faThumbsDown,
  faPaperPlane,
  faPenSquare,
  faUserPlus,
  faTimes,
  faPen,
  faTrashAlt,
  faSave,
  faTimesCircle,
  faCheckCircle,
  faEllipsisV,
  faEdit,
  faEye,
  faDownload,
  faUsers,
  faClipboardCheck,
  faExclamationTriangle,
  faExclamationCircle,
  faExchangeAlt,
  faSearchPlus,
  faArrowRight,
  faList,
  faComments,
  faStar,
  faStarHalf,
  faPhoneAlt,
  faMobileAlt,
  faEnvelopeOpenText,
  faEnvelope,
  faBuilding,
  faHome,
  faCommentDots,
  faRobot,
  faUsersCog,
  faSitemap,
  faProjectDiagram,
  faFolderOpen,
  faChartLine,
  faBell,
  faHeart,
  faHandHoldingHeart,
  faQrcode,
  faTags,
  faBullseye,
  faClipboard,
  faPaperclip,
  faInfinity,
  faReply,
  faReplyAll,
  faCommentAlt,
  faEllipsisH,
  faClock,
  faFlag,
  faTable,
  faThLarge,
  faAngleLeft,
  faAngleRight,
  faChevronDown,
  faSms,
  faLock,
  faLockOpen,
  faMapMarkerAlt,
  faHourglass,
  faFolderPlus,
  faFileAlt,
);

export default library;



// WEBPACK FOOTER //
// ./src/fontAwesome.js